import { DeleteOutlined } from '@ant-design/icons';
import { Button, Popconfirm, message } from 'antd';
import { FC, useCallback, useState } from 'react';
import { useAuth } from 'src/stores/auth-context';

import { errorObjectToString } from 'src/utils/common';
import { deletePartnersUser } from 'src/utils/firebase/firebase-short-cut';

type AgCellDeletePartnersUserProps = {
  id: string;
  disabled?: boolean;
};

const AgCellDeletePartnersUser: FC<AgCellDeletePartnersUserProps> = ({ id, disabled }) => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleOnClick = useCallback(async () => {
    setLoading(true);
    try {
      await deletePartnersUser(id);
    } catch (error) {
      console.error(error);
      message.error(errorObjectToString(error));
    }
    setLoading(false);
  }, [id]);

  if (user?.role !== 'admin') return null;

  return (
    <Popconfirm
      disabled={disabled}
      placement='bottomRight'
      title='삭제하시겠습니까?'
      onConfirm={handleOnClick}
      okText='삭제'
      cancelText='취소'
      okButtonProps={{ loading }}>
      <Button
        size='small'
        type='primary'
        danger
        loading={loading}
        disabled={disabled}
        style={{ fontSize: 12, marginLeft: 4 }}
        icon={<DeleteOutlined />}>
        삭제
      </Button>
    </Popconfirm>
  );
};

export default AgCellDeletePartnersUser;
